import {
  ExportedPublicMediaPlatform,
  MediaPlatform,
} from '@wix/media-platform-js-client/browser';

import { getConfig } from '../config';
import { Project } from '../types/entities';

import { BASE_PATH, PROJECT_PATH } from './services/config';

export type MediaPlatformSDK = ExportedPublicMediaPlatform;

class MediaPlatformProvider {
  public MP: MediaPlatformSDK;
  public storage = new Map<string, MediaPlatform>();

  public getAuthUrl(organizationId: string, project: Project) {
    return `${
      getConfig().api.baseUrl
    }${BASE_PATH}/${organizationId}${PROJECT_PATH}/${
      project.id
    }/assets_manager/token`;
  }

  public getSDKInstance(
    organizationId: string,
    project: Project,
  ): MediaPlatform {
    const SDKInstance = this.storage.get(organizationId + project.id);
    if (SDKInstance === undefined) {
      throw Error('no sdk instance');
    }
    return SDKInstance;
  }

  public getMediaPlatform(): MediaPlatformSDK {
    return this.MP;
  }

  public initMediaPlatform(organizationId: string, project: Project) {
    const key = organizationId + project.id;

    if (this.storage.has(key)) {
      return this.storage.get(key);
    }

    const MP = this.getMediaPlatform();
    const mediaPlatform = new MP.MediaPlatform({
      domain: project.domain,
      authenticationUrl: this.getAuthUrl(organizationId, project),
    });

    return this.storage.set(key, mediaPlatform).get(key);
  }

  public setMediaPlatform(MP) {
    this.MP = MP;
  }

  public load(organizationId: string, project?: Project) {
    if (!project) {
      throw new Error('project does not exist');
    }

    // I want to load JS SDK in async way
    return import(
      /* webpackChunkName: "@wix/media-platform-js-client" */ '@wix/media-platform-js-client/browser'
    ).then((MP) => {
      this.setMediaPlatform(MP);
      return this.initMediaPlatform(organizationId, project);
    });
  }
}

export const mediaPlatformProvider = new MediaPlatformProvider();
